import {
  UIStore,
} from 'Internal';


export const AppUIStore = UIStore.named('AppUIStore');
